import Link24 from './Link24';
import Link16 from './Link16';
type Props = {
  size?: 16 | 24;
  color?: string;
  [key: string]: any;
};

const assets = {
  24: Link24,
  16: Link16,
};

export default ({ size = 16, color, ...args }: Props) => {
  const Asset = assets[size];
  return (
    <span className="oksoon-icon oksoon-icon--Link" {...args}>
      <Asset color={color} />
    </span>
  );
};
